import type { AnnotationsIntegrationTrackConfig } from '../../../../charts/core/components/annotations/components/indicators/types.js';
import { populateMissingMarkerProps } from '../../../../charts/core/components/annotations/utils/populate-missing-marker-props.js';
import { populateMissingTrackProps } from '../../../../charts/core/components/annotations/utils/populate-missing-track-props.js';
import type { GanttAnnotationsTrackConfig } from '../../../../charts/gantt-chart/types/gantt-chart.js';

/**
 * Converts GanttAnnotationsTrackConfig to AnnotationsIntegrationTrackConfig
 * by populating missing marker and track props and preserving indicatorsDisplay.
 * @param tracks - The array of gantt annotation track configs to convert.
 * @returns An array of AnnotationsIntegrationTrackConfig that includes all necessary props.
 * @internal
 */
export function toIntegrationTracks(
  tracks: GanttAnnotationsTrackConfig[],
): AnnotationsIntegrationTrackConfig[] {
  return tracks.map((track) => {
    const markers = track.markers.map((marker) => ({
      ...populateMissingMarkerProps(marker, track),
      indicatorsDisplay: marker.indicatorsDisplay,
    }));
    return {
      ...populateMissingTrackProps({ ...track, markers }),
      indicatorsDisplay: track.indicatorsDisplay,
    };
  });
}
